__turbopack_context__.v({
  "active": "HeroSlider-module-scss-module__iMfm_G__active",
  "arrowButton": "HeroSlider-module-scss-module__iMfm_G__arrowButton",
  "arrows": "HeroSlider-module-scss-module__iMfm_G__arrows",
  "contentRaised": "HeroSlider-module-scss-module__iMfm_G__contentRaised",
  "desktopOnly": "HeroSlider-module-scss-module__iMfm_G__desktopOnly",
  "dot": "HeroSlider-module-scss-module__iMfm_G__dot",
  "dots": "HeroSlider-module-scss-module__iMfm_G__dots",
  "dynamicArrowButton": "HeroSlider-module-scss-module__iMfm_G__dynamicArrowButton",
  "dynamicArrows": "HeroSlider-module-scss-module__iMfm_G__dynamicArrows",
  "dynamicBackground": "HeroSlider-module-scss-module__iMfm_G__dynamicBackground",
  "dynamicBackgroundImage": "HeroSlider-module-scss-module__iMfm_G__dynamicBackgroundImage",
  "dynamicContent": "HeroSlider-module-scss-module__iMfm_G__dynamicContent",
  "dynamicContentActive": "HeroSlider-module-scss-module__iMfm_G__dynamicContentActive",
  "dynamicHeading": "HeroSlider-module-scss-module__iMfm_G__dynamicHeading",
  "dynamicHero": "HeroSlider-module-scss-module__iMfm_G__dynamicHero",
  "dynamicNavControls": "HeroSlider-module-scss-module__iMfm_G__dynamicNavControls",
  "dynamicOverlay": "HeroSlider-module-scss-module__iMfm_G__dynamicOverlay",
  "dynamicOverlayHidden": "HeroSlider-module-scss-module__iMfm_G__dynamicOverlayHidden",
  "dynamicProgressBar": "HeroSlider-module-scss-module__iMfm_G__dynamicProgressBar",
  "dynamicProgressFill": "HeroSlider-module-scss-module__iMfm_G__dynamicProgressFill",
  "dynamicSlide": "HeroSlider-module-scss-module__iMfm_G__dynamicSlide",
  "dynamicSlides": "HeroSlider-module-scss-module__iMfm_G__dynamicSlides",
  "dynamicSubtitleAbove": "HeroSlider-module-scss-module__iMfm_G__dynamicSubtitleAbove",
  "expandingOverlay": "HeroSlider-module-scss-module__iMfm_G__expandingOverlay",
  "expandingOverlayExpanded": "HeroSlider-module-scss-module__iMfm_G__expandingOverlayExpanded",
  "fixedTop": "HeroSlider-module-scss-module__iMfm_G__fixedTop",
  "isExpanding": "HeroSlider-module-scss-module__iMfm_G__isExpanding",
  "isShrinking": "HeroSlider-module-scss-module__iMfm_G__isShrinking",
  "mobileOnly": "HeroSlider-module-scss-module__iMfm_G__mobileOnly",
  "paused": "HeroSlider-module-scss-module__iMfm_G__paused",
  "progress": "HeroSlider-module-scss-module__iMfm_G__progress",
  "progressBar": "HeroSlider-module-scss-module__iMfm_G__progressBar",
  "progressContainer": "HeroSlider-module-scss-module__iMfm_G__progressContainer",
  "shrinkingOverlay": "HeroSlider-module-scss-module__iMfm_G__shrinkingOverlay",
  "shrinkingOverlayShrunk": "HeroSlider-module-scss-module__iMfm_G__shrinkingOverlayShrunk",
  "slide": "HeroSlider-module-scss-module__iMfm_G__slide",
  "slider": "HeroSlider-module-scss-module__iMfm_G__slider",
  "slides": "HeroSlider-module-scss-module__iMfm_G__slides",
  "thumbnail": "HeroSlider-module-scss-module__iMfm_G__thumbnail",
  "thumbnailActive": "HeroSlider-module-scss-module__iMfm_G__thumbnailActive",
  "thumbnailContent": "HeroSlider-module-scss-module__iMfm_G__thumbnailContent",
  "thumbnailEnterGrow": "HeroSlider-module-scss-module__iMfm_G__thumbnailEnterGrow",
  "thumbnailEntering": "HeroSlider-module-scss-module__iMfm_G__thumbnailEntering",
  "thumbnailEnteringVisible": "HeroSlider-module-scss-module__iMfm_G__thumbnailEnteringVisible",
  "thumbnailExiting": "HeroSlider-module-scss-module__iMfm_G__thumbnailExiting",
  "thumbnailFadingOut": "HeroSlider-module-scss-module__iMfm_G__thumbnailFadingOut",
  "thumbnailHeading": "HeroSlider-module-scss-module__iMfm_G__thumbnailHeading",
  "thumbnailImage": "HeroSlider-module-scss-module__iMfm_G__thumbnailImage",
  "thumbnailSection": "HeroSlider-module-scss-module__iMfm_G__thumbnailSection",
  "thumbnailStrip": "HeroSlider-module-scss-module__iMfm_G__thumbnailStrip",
  "thumbnailSubtitleAbove": "HeroSlider-module-scss-module__iMfm_G__thumbnailSubtitleAbove",
});
